import { render, staticRenderFns } from "./FaqWidget.vue?vue&type=template&id=783e6f8e&"
import script from "./FaqWidget.vue?vue&type=script&lang=js&"
export * from "./FaqWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports